import React, {Component} from 'react';
import {TextInput} from 'admin-on-rest';
import {ChromePicker} from 'react-color';
import {Field} from 'redux-form';

/**
 * A TextInput component with React Color picker functionality
 *
 */
class ColorPickerTextInput extends Component {
    state = {
        show: false,
        selectedColor: '',
    };

    componentDidMount() {
        this.setState({
            selectedColor: this.props[this.props.color]
        });
    }

    handleOpen = () => this.setState({show: true});
    handleClose = () => this.setState({show: false});
    handleChange = ({hex}) => {
        this.props.input.onChange(hex);
        this.forceUpdate();
    };
    handleChangeComplete = (color, event) => {
        this.setState({
            selectecColor: color.hex,
        });
    };

    render() {
        const {
            input
        } = this.props;

        const styles = {
            popup: {position: 'absolute', zIndex: 2},
            cover: {position: 'fixed', top: 0, right: 0, bottom: 0, left: 0},
            picker: {marginTop: '-100px', marginLeft: '50px'}
        };

        return (
            <div>
                <Field {...input}
                       name={this.props.source}
                       component={TextInput}
                       source={this.props.source}
                       label={this.props.label}
                       value={this.props.selectedColor}
                       onFocus={this.handleOpen}
                       validate={this.props.validate}
                />
                {
                    this.state.show ?
                        <div style={styles.popup}>
                            <div onClick={this.handleClose} style={styles.cover}/>
                            <div style={styles.picker}>
                                <ChromePicker
                                    color={input.value}
                                    onChange={this.handleChange}
                                    onChangeComplete={this.handleChangeComplete}
                                    disableAlpha={true}/>
                            </div>
                        </div>
                        : null
                }
            </div>
        );
    }
}

ColorPickerTextInput.propTypes = TextInput.propTypes;
ColorPickerTextInput.defaultProps = TextInput.defaultProps;
ColorPickerTextInput.defaultProps.addField = true;

export default ColorPickerTextInput;


// WEBPACK FOOTER //
// ./src/Fuse/components/ColorPickerTextInput.js